module.exports = __webpack_public_path__ + "img/exclamation-error.38ebe0da.png";